const Intro = () => import( /* webpackchunkName: "intro" */ '@/views/index/IntroView')
const Vote = () => import( /* webpackchunkName: "vote" */ '@/views/index/VoteView')
const Rank = () => import( /* webpackchunkName: "rank" */ '@/views/index/RankView')
const Enroll = () => import( /* webpackchunkName: "enroll" */ '@/views/index/EnrollView')
const Detail = () => import( /* webpackchunkName: "detail" */ '@/views/index/DetailView')
const NotFound = () => import( /* webpackchunkName: "404" */ '@/views/index/NotFound')

export default [
  { path: '/', redirect: '/show' },
  {
    path: '/show',
    name: 'show',
    component: () => import('@/views/ShowView'),
    children: [
      { path: '/intro', name: 'intro', component: Intro },
      { path: '/vote', name: 'vote', component: Vote , meta: {
        keepAlive: true
      }},
      { path: '/rank', name: 'rank', component: Rank },
      { path: '/enroll', name: 'enroll', component: Enroll },
      { path: '/detail', name: 'vote.detail', component: Detail },
      { path: '/404', name: '404', component: NotFound },
    ]
  },
]